/**
 * @Author: Nenad Brcic
 * @Date: 25.09.16
 * @Email: neno@neno.ch
 */

import React, { PropTypes } from 'react';
import Icon from '../Icon';
import styles from './list-entry.scss';
import CSSModules from 'react-css-modules';

const ListEntryDelete = ({ id, onClick }) => (
    <button styleName="button-delete" onClick={ () => onClick(id) }>
        <Icon icon="Vitra_Close.svg" />
    </button>
);

ListEntryDelete.propTypes = {
    onClick: PropTypes.func.isRequired,
    id: PropTypes.string.isRequired,
}

export default CSSModules(ListEntryDelete, styles);


// WEBPACK FOOTER //
// ./app/components/shared/ListEntry/ListEntryDelete.jsx